import "bootstrap";

import $ from "jquery";
import LazyLoad from "vanilla-lazyload";
// import local dependencies
import Router from "./utils/Router";
import common from "./routes/common";
import pageAccount from "./routes/account";
import pageCart from "./routes/cart";
import pageCategory from "./routes/category";
import pageHome from "./routes/home";
import pageOrderDelivery from "./routes/delivery";
import pageOrderInvoice from "./routes/invoice";
import pageRegister from "./routes/register";
require("magnify");

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  pageHome,
  pageCategory,
  pageCart,
  pageRegister,
  pageAccount,
  pageOrderDelivery,
  pageOrderInvoice,
});

export const LazyLoadManager = new LazyLoad({
  threshold: 0,
  elements_selector: "[data-src][data-lazy]",
});

// Load Events
document.addEventListener("DOMContentLoaded", () => routes.loadEvents());



// WEBPACK FOOTER //
// ./assets/src/js/app.js